<!-- src/views/HomeView.vue -->
<template>
    <div>
      <h1>Welcome to the Home Page</h1>
    </div>
  </template>
  
  <script>
  export default {
    name: 'HomeView',
  };
  </script>
  